import { render } from "./OfferListBox.vue?vue&type=template&id=151c3cac&scoped=true&bindings={\"price\":\"props\",\"name\":\"props\",\"id\":\"props\",\"currency\":\"props\",\"img\":\"props\",\"obiektNazwa\":\"props\",\"obiektTransakcjaShort\":\"props\",\"powierzchnia\":\"props\",\"lokalizacja\":\"props\",\"areaFormatted\":\"options\",\"priceFormatted\":\"options\",\"projectImagePath\":\"options\"}"
import script from "./OfferListBox.vue?vue&type=script&lang=js"
export * from "./OfferListBox.vue?vue&type=script&lang=js"

import "./OfferListBox.vue?vue&type=style&index=0&id=151c3cac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-151c3cac"

export default script